import NonRKPayInvoiceStatusHistoryModal from "./NonRKPayInvoiceStatusHistoryModal";

export default NonRKPayInvoiceStatusHistoryModal;
